// Core
import { createActions } from 'redux-actions';

export const hotActions = createActions({
    GET_BLOCK:         (blockId) => blockId,
    GET_BLOCK_SUCCESS: (blockId, tours) => ({ blockId, tours }),
    GET_BLOCK_FAIL:    (error) => error,

    GET_TOUR:         (blockId, tourId) => ({ blockId, tourId }),
    GET_TOUR_SUCCESS: (tourId, hotels) => ({ tourId, hotels }),
    GET_TOUR_FAIL:    (error) => error,

    GET_TOURS_COUNTRIES:         () => void 0,
    GET_TOURS_COUNTRIES_SUCCESS: (countries) => countries,
    GET_TOURS_COUNTRIES_FAIL:    (error) => error,

    GET_COUNTRY_RECOMMENDED_TOURS:         (countryId) => countryId,
    GET_COUNTRY_RECOMMENDED_TOURS_SUCCESS: (countryId, blocks) => ({ countryId, blocks }),
    GET_COUNTRY_RECOMMENDED_TOURS_FAIL:    (error) => error,
});
